import { LOGO_URL, BUSINESS_PHONE, BUSINESS_PHONE_DISPLAY } from "./constants";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 bg-[#070b13] px-6 py-12 text-slate-400 text-xs"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Revive & Drive Auto LLC logo"
            data-testid="footer-logo"
            className="h-9 w-auto rounded border border-white/10"
          />
          <span className="font-bold text-white text-sm">Revive &amp; Drive Auto LLC</span>
        </div>
        <div className="flex flex-col items-center gap-1">
          <p data-testid="footer-service-area">
            Serving Dayton &amp; Cincinnati and surrounding areas &bull; On-site mobile mechanic &amp; roadside assistance
          </p>
          <a
            href={`tel:${BUSINESS_PHONE}`}
            data-testid="footer-phone-link"
            className="text-cyan-300 hover:text-cyan-200 font-mono-lbl transition-colors"
          >
            {BUSINESS_PHONE_DISPLAY}
          </a>
        </div>
        <p className="font-mono-lbl text-[10px]">
          &copy; Revive &amp; Drive Auto LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
